import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ShieldVirus = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M224 192a16 16 0 1 0 16 16 16 16 0 0 0-16-16zM466.5 83.68l-192-80A57.4 57.4 0 0 0 256.05 0a57.4 57.4 0 0 0-18.46 3.67l-192 80A47.93 47.93 0 0 0 16 128c0 198.5 114.5 335.72 221.5 380.32a48.09 48.09 0 0 0 36.91 0C360.09 472.61 496 349.3 496 128a48 48 0 0 0-29.5-44.32zM384 256h-12.12c-28.51 0-42.79 34.47-22.63 54.63l8.58 8.57a16 16 0 1 1-22.63 22.63l-8.57-8.58c-20.16-20.16-54.63-5.88-54.63 22.63V368a16 16 0 0 1-32 0v-12.12c0-28.51-34.47-42.79-54.63-22.63l-8.57 8.58a16 16 0 0 1-22.63-22.63l8.58-8.57c20.16-20.16 5.88-54.63-22.63-54.63H128a16 16 0 0 1 0-32h12.12c28.51 0 42.79-34.47 22.63-54.63l-8.58-8.57a16 16 0 0 1 22.63-22.63l8.57 8.58c20.16 20.16 54.63 5.88 54.63-22.63V112a16 16 0 0 1 32 0v12.12c0 28.51 34.47 42.79 54.63 22.63l8.57-8.58a16 16 0 0 1 22.63 22.63l-8.58 8.57c-20.16 20.16-5.88 54.63 22.63 54.63H384a16 16 0 0 1 0 32zm-96 0a16 16 0 1 0 16 16 16 16 0 0 0-16-16z"
  }));
});
ShieldVirus.displayName = 'ShieldVirus';
export var ShieldVirusDimensions = {
  height: 512,
  width: 512
};